<template>
  <div>
    <h3>Your Files
      <a
        class="btn btn-sm btn-primary m-l-xl"
        type="submit"
        @click="handleGetFileInput">
        <i class="fa fa-plus"></i> Upload Files
      </a>
      <input style="display: none;" ref="fileInput" type="file" multiple @change="this.handleAddBookingFiles">
    </h3>
    <hr />
    <ul style="padding: 0;" v-if="hasFiles">
      <request-file-list-item v-for="file in booking.files" :key="file.id" :file="file" :booking="booking"/>
    </ul>
    <no-results v-else>
      There are currently no files.
    </no-results>
  </div>
</template>

<script>
import { notify } from 'utils'
import RequestFileListItem from './RequestFileListItem'
import {mapActions, mapState} from "vuex";

export default {
  props: {
    booking: {
      required: true,
      type: Object
    }
  },
  created () {
    this.getBookingFiles({ id: this.booking.id })
  },
  computed: {
    ...mapState('booking/file', ['files', 'loading']),
    hasFiles () {
      return this.booking.files && this.booking.files.length
    }
  },
  methods: {
    ...mapActions('booking/file', ['getBookingFiles', 'storeBookingFile', 'destroyFile', 'downloadFile', 'setFilesLoading']),
    /*
     * Opens the file input window
     *
     * @return void
     */
    handleGetFileInput () {
      this.$refs.fileInput.value = null
      this.$refs.fileInput.click()
    },

    handleAddBookingFiles ({ target: { files } }) {
      if (files.length !== 0) {
        let bookingFiles = this.booking.files !== undefined ? this.booking.files : []
        for (let i = 0; i < files.length; i++) {
          if (files[i].size >= 15000000) {
            notify.error('Maximum file size is 15MB. Unable to upload file: ' + files[i].name)
          } else {
            bookingFiles.push(files[i])
          }
        }
        this.booking.files = bookingFiles
      }
    }
  },

  components: {
    RequestFileListItem
  }
}
</script>
